import React from "react";

import './styles.css'

import CloseIcon from '@mui/icons-material/Close';
import {
  Stack,
  IconButton,
  Box,
  //Modal,
  Typography,
} from '@mui/material';

function VerExPopUp(props){
  //const [choose, setChoose] = useState('Disponível');

  //const handleChoose = () => {
  //  setChoose('Escolhido');
  //}

  return (props.trigger) ? (
    <Box className="popup">
      
        <Box className="popup-inner">
            {/*props.ex.membros {props.ex.name} */ }
            {/*
            <Typography sx={{paddingTop:0.7}} variant="h5">{props.content.name}</Typography>
            <Typography variant="body2">{props.content.description}</Typography>
            */}

            <Stack p={0} direction='column' sx={{ height: 300, overflow: "hidden", overflowY: "scroll"}}>
                <Typography variant="subtitle1">
                Instruções
                </Typography>
                
                {props.content.instrucoes.map((inst) => (
                    <Typography key={inst.ordem} variant="body2">
                     {inst.ordem} — {inst.instrucao}
                    </Typography>
                ))}
                
            </Stack>
            {/*
            <Stack p={0} direction='column'>
                <Typography variant="subtitle1">
                Exemplo
                </Typography>
            </Stack>
            */}
            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
    </Box>
      /*
      <div className="popup">
        <div className="popup-inner">
            <button className="close-btn" onClick={() => props.setTrigger(false)}>
            Fechar
            </button>
            {props.children}
        </div>
    </div>
    */
  ) : "";
}
export default VerExPopUp
